/* eslint-disable */
import React from "react";
import { Commodities } from '../../../controls/Commodities';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";
import { SLIDE_NUMBER } from "../constants";
import { orderBy } from "lodash";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';

interface ControlItem extends HierarchyControlItem<number> {

}

const BUSINESS_UNIT = 1;

export const UnitsControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);

    const [commodityValue] = useParameter<number | null>("@commodities");
    const [unitValue, setUnitValue] = useParameter<number | null>("@units");


    const [dictItems, , loading] = useDictionary(dictionaryService, "slides-units-slide33", undefined, {
        commodity_id: commodityValue,
    });

    React.useEffect(function updateControlItems() {
        if (dictItems) {
            const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
            const nextControlItems = sortedDictItems.map<ControlItem>(dictItem => ({
                id: Number(dictItem.id),
                name: (dictItem.getValue("name") as any)[9] as string,
            }));
            setControlItems(nextControlItems);

            let selectedItem = nextControlItems.find(item => item.id === unitValue);
            if (selectedItem === undefined && nextControlItems[0]) {
                const firstItem = nextControlItems[0];
                setUnitValue(firstItem.id);
            }
        }
    }, [dictItems]);

    const handlerChange = React.useCallback((selectedId: number | undefined | null) => {
        selectedId && setUnitValue(selectedId);
    }, []);

    return (
        <HierarchyControl
            loading={loading}
            label="Unit"
            value={unitValue}
            onChange={handlerChange}
            items={controlItems}
        />
    )
};
